import React, { useMemo } from "react";
import Wrapper from "./esignOtpInput.styles";

const EsignOtpInput = ({ value, valueLength, onChange, isDisabled, name }) => {
    const reDigit = new RegExp(/^\d+$/);
    const valueItems = useMemo(() => {
      const valueArray = value.split("");
      const items = [];
  
      for (let i = 0; i < valueLength; i++) {
        const char = valueArray[i];
  
        if (reDigit.test(char)) {
          items.push(char);
        } else {
          items.push("");
        }
      }
  
      return items;
    }, [value, valueLength, reDigit]);
  
    const focusToNextInput = (target) => {
      const nextElementSibling = target.nextElementSibling;
  
      if (nextElementSibling) {
        nextElementSibling.focus();
      }
    };
  
    const focusToPrevInput = (target) => {
      const previousElementSibling = target.previousElementSibling;
  
      if (previousElementSibling) {
        previousElementSibling.focus();
      }
    };
  
    const inputOnChange = (e, index) => {
      const target = e.target;
      let targetValue = target.value.trim();
      const isTargetValueDigit = reDigit.test(targetValue);
  
      if (!isTargetValueDigit && targetValue !== "") {
        return;
      }
  
      const nextInputElement = target.nextElementSibling;
  
      if (!isTargetValueDigit && nextInputElement && nextInputElement.value !== "") {
        return;
      }
  
      targetValue = isTargetValueDigit ? targetValue : " ";
  
      const targetValueLength = targetValue.length;
  
      if (targetValueLength === 1) {
        const newValue =
          value.substring(0, index) + targetValue + value.substring(index + 1);
  
        onChange(newValue);
  
        if (!isTargetValueDigit) {
          return;
        }
  
        const nextElementSibling = target.nextElementSibling;
  
        if (nextElementSibling) {
          nextElementSibling.focus();
        }
  
        focusToNextInput(target);
      } else if (targetValueLength === valueLength) {
        onChange(targetValue);
  
        target.blur();
      }
    };
  
    const inputOnKeyDown = (e) => {
      const { key } = e;
      const target = e.target;
  
      if (key === "ArrowRight" || key === "ArrowDown") {
        e.preventDefault();
        return focusToNextInput(target);
      }
  
      if (key === "ArrowLeft" || key === "ArrowUp") {
        e.preventDefault();
        return focusToPrevInput(target);
      }
  
      const targetValue = target.value;
  
      target.setSelectionRange(0, targetValue.length);
  
      if (e.key !== "Backspace" || target.value !== "") {
        return;
      }
  
      const previousElementSibling = target.previousElementSibling;
  
      if (previousElementSibling) {
        previousElementSibling.focus();
      }
  
      focusToPrevInput(target);
    };
  
    const inputOnFocus = (e) => {
      const { target } = e;
  
      const prevInputElement = target.previousElementSibling;
  
      if (prevInputElement && prevInputElement.value === "") {
        return prevInputElement.focus();
      }
  
      target.setSelectionRange(0, target.value.length);
    };
  
    return (
      <Wrapper>
        {valueItems.map((digit, index) => (
          <input
            name={name}
            key={index}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="\d{1}"
            maxLength={valueLength}
            className="otp-input"
            value={digit}
            onChange={(e) => inputOnChange(e, index)}
            onKeyDown={inputOnKeyDown}
            onFocus={inputOnFocus}
            disabled={isDisabled}
          />
        ))}
      </Wrapper>
    );
  };
  
export default EsignOtpInput;